<template>
  <div class="LeftCover-RightTitle">
    <div class="item-container">
      <div
        v-for="(item,index) in cp_list"
        :key="index"
        class="item"
        @click="onClickItem(item)"
      >
        <div class="image">
          <web-img
            class="left-img"
            width="100%"
            height="100%"
            fit="cover"
            :src="item.imageUrl"
          />
        </div>
        <div class="right-content">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="introduction">
            {{ item.content }}
          </div>
          <div class="time">
            {{ item.formatDate }}
          </div>
        </div>
      </div>
    </div>
    <seeMore
      v-if="list.length > 4"
      @click="goMore"
    />
  </div>
</template>

<script>
import webImg from '../webImg';
import seeMore from '../seeMore';
import { findRootNode, openUrl } from '../../../../../../lib/utils';

export default {
    name: 'LeftCoverRightTitle',
    components: {
        webImg, seeMore,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        rootId: {
            type: [String, Number],
            default: '',
        },
        list: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        cp_list () {
            let result = this.list;
            if (this.list.length > 4) {
                result = this.list.slice(0, 4);
            }
            return result.map(itm => {
                const date = new Date(itm.createTime);
                const year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                month = month < 10 ? '0' + month : month;
                day = day < 10 ? '0' + day : day;
                return Object.assign(itm, { formatDate: `${year}-${month}-${day}` });
            });
        },
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
        rootNode () {
            return findRootNode(this.flatTreeList, this.rootId);
        },
        catalogId () {
            const node = this.flatTreeList.find(itm => +itm.pCatalogId === this.rootNode.catalogId);
            if (node) return node.catalogId;
            return this.rootNode.catalogId;
        },
    },
    methods: {
        onClickItem (item) {
            const query = this.$route.query;
            const routeUrl = this.$router.resolve({
                path: '/webModulePage/articleDetail',
                query: {
                    catalogId: this.catalogId,
                    currCatalogId: item.catalogId,
                    contentId: item.contentId,
                    siteId: query.siteId,
                    preview: query.preview,
                    from: 'home',
                },
            });
            openUrl(routeUrl.href);
        },
        goMore () {
            const query = this.$route.query;
            const routeUrl = this.$router.resolve({
                path: '/webModulePage/articleList',
                query: {
                    catalogId: this.catalogId,
                    siteId: query.siteId,
                    preview: query.preview,
                    from: 'home',
                },
            });
            openUrl(routeUrl.href);
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../style.scss";
.LeftCover-RightTitle {
    width: 100%;
    background-color: #F9F9F9;
    .item-container {
        width: $pageWidth;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        .item {
            width: 594px;
            height: 220px;
            background-color: #FFFFFF;
            box-sizing: border-box;
            padding: 20px;
            cursor: pointer;
            transition: box-shadow .3s;
            display: flex;
            justify-content: space-between;
            border-radius: 4px;
            &:nth-child(odd) {
                margin-right: 20px;
                margin-bottom: 20px;
            }
            &:hover {
                .image .left-img {
                    transform: scale(1.12);
                }
                box-shadow: 0px 4px 10px 0px rgba(12, 17, 40, 0.1);
            }
            .image {
                width: 180px;
                height: 180px;
                overflow: hidden;
                border-radius: 4px;
                margin-right: 20px;
                .left-img {
                    transform: scale(1.02);
                    transition: transform .5s;
                }
            }
            .right-content {
                width: 350px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .title {
                    width: 100%;
                    font-size: 18px;
                    color: #464C5B;
                    font-weight: 600;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
                .introduction {
                    width: 100%;
                    font-size: 16px;
                    color: #657180;
                    line-height: 30px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    overflow: hidden;
                    -webkit-line-clamp: 3;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                    /* autoprefixer: on */
                    text-align: justify;
                    word-break: break-all;
                }
                .time {
                    font-size: 14px;
                    color: #C3CBD6;
                    width: 100%;
                    text-align: right;
                }
            }
        }
    }
}
</style>
